type ActivityType = (typeof ACTIVITY_TYPES)[number];

const ACTIVITY_TYPES = [
  'eat',
  'entertainment',
  'grocery',
  'medical',
  'outdoor',
  'retail',
  'home',
  'work',
  'others',
] as const;

export type { ActivityType };
export { ACTIVITY_TYPES };
